import { sbefGroupIds } from '../construction/sbef.model';
import type { ScopeQueryDimensions } from './scope-query-params.helpers';

const KEY_SEPARATOR = ';';
const LIST_SEPARATOR = ',';

/**
 * Stable identity of a scope, used to key the targets a project holds
 * (`ProjectMetadata.scope_targets`). The string it returns is **persisted**:
 * it is written into project documents and into the migration that moved the
 * old project-wide target onto the Boverket scope, so renaming a `Lifecycle` or
 * `SbefGroupCode` value — or changing the format here — orphans every target
 * stored under the old key, silently dropping those projects back to the
 * fallback. Such a change needs a migration of its own. A scope is what it counts — lifecycles,
 * SBEF groups and generic-carbon convention — and nothing else, so a preset and
 * a hand-made selection that count the same thing are the same scope and share
 * one target. "No SBEF filter" is spelled out as every group, since an empty
 * selection means exactly that.
 */
export const getScopeTargetKey = ({
  lifecycles,
  sbefGroups,
  conservative,
}: ScopeQueryDimensions): string => {
  const groups = sbefGroups.length === 0 ? [...sbefGroupIds] : [...sbefGroups];
  return [
    `lifecycles=${[...lifecycles].sort().join(LIST_SEPARATOR)}`,
    `sbefGroups=${groups.sort().join(LIST_SEPARATOR)}`,
    `conservative=${conservative ? 1 : 0}`,
  ].join(KEY_SEPARATOR);
};
